export default "__VITE_ASSET__fffa7a91__"